
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/termsncond",
      function () {
        return require("private-next-pages/legal/termsncond.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/termsncond"])
      });
    }
  